const ColoredCalendar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M13.8338 1.33325H2.16715C1.24668 1.33325 0.500488 2.07944 0.500488 2.99992V14.6666C0.500488 15.5871 1.24668 16.3333 2.16715 16.3333H13.8338C14.7543 16.3333 15.5005 15.5871 15.5005 14.6666V2.99992C15.5005 2.07944 14.7543 1.33325 13.8338 1.33325Z"
      fill="white"
    />
    <path
      d="M0.500488 2.375C0.500488 1.33947 1.33995 0.5 2.37549 0.5H13.6255C14.661 0.5 15.5005 1.33947 15.5005 2.375V5.5H0.500488V2.375Z"
      fill="#A4F0FF"
    />
  </svg>
);

export default ColoredCalendar;
